import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CrossIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 8)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
    >
      <path d="m1 7 6-6M7 7 1 1" />
    </SVG>
  );
};
